import React from 'react';
import styled from 'styled-components';

// Styled Components based on FAQsPage.css and Style Guide
const FAQsPageWrapper = styled.div`
  max-width: 800px;
  margin: 40px auto; /* Added more top/bottom margin */
  padding: 30px 20px;
  font-family: 'Oswald', 'Arial Black', sans-serif; /* Primary font from Style Guide */
  color: #133B5C; /* Primary text color - Navy Blue */
  background-color: #F9F6F1; /* Off-White/Canvas background for the page */
  border-radius: 8px; /* Consistent rounded corners */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Subtle shadow for page container */
`;

const PageTitle = styled.h1`
  text-align: center;
  margin-bottom: 25px;
  color: #133B5C; /* Navy Blue */
  font-family: 'Oswald', sans-serif;
  text-transform: uppercase;
  font-weight: bold;
`;

const IntroParagraph = styled.p`
  text-align: center;
  font-size: 1.1em;
  line-height: 1.7;
  color: #133B5C; /* Navy Blue */
  margin-bottom: 30px;
  font-family: Arial, sans-serif; /* Fallback for paragraphs */
`;

const FAQsSubheading = styled.h2`
  text-align: center;
  font-family: 'Oswald', sans-serif;
  text-transform: uppercase;
  color: #2A7131; /* Forest Green */
  margin-top: 40px;
  margin-bottom: 25px;
  font-size: 1.5em;
  font-weight: bold;
`;

const FAQItemWrapper = styled.div`
  background-color: #FFFFFF; /* White background for individual FAQ items */
  border: 1px solid #999589; /* Warm Gray border */
  border-radius: 8px;
  padding: 20px 25px;
  margin-bottom: 25px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s ease-in-out;

  &:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  }
`;

const FAQQuestion = styled.h3`
  color: #133B5C; /* Navy Blue */
  margin-top: 0;
  margin-bottom: 12px;
  font-size: 1.2em;
  font-family: 'Oswald', sans-serif;
  font-weight: bold;
`;

const FAQAnswer = styled.p`
  line-height: 1.6;
  color: #133B5C; /* Navy Blue for answers as well, for consistency */
  margin-bottom: 0;
  font-size: 1em;
  font-family: Arial, sans-serif; /* Fallback for paragraphs */
`;


const faqsData = [
  {
    question: "Is there a fee to join?",
    answer: "No. There is no annual fee to join."
  },
  {
    question: "What rebates will I get?",
    answer: "Depending on the manufacturer and the products purchased, you will earn 0.5%-5.5%"
  },
  {
    question: "What if I don't purchase all the manufacturers listed on the website?",
    answer: "You only receive rebates on the manufacturer products that you do purchase."
  },
  {
    question: "Can I get rebates on more manufacturers than the ones listed?",
    answer: "No, Vending Rebates only focuses on the programs for the manufacturers that are listed"
  },
  {
    question: "Does this interfere with my other rebates?",
    answer: "Vending Rebates focuses ONLY on the manufacturers listed; our programs will not affect your other rebates."
  },
  {
    question: "How does it work?",
    answer: "Vending Rebates obtains the manufacturer data from the several distributor options that are on the signup form."
  },
  {
    question: "When will I start earning rebates?",
    answer: "New members are submitted at the beginning of the upcoming quarter to start earning rebates."
  },
  {
    question: "When will I receive my first check?",
    answer: "Purchase data is received from the manufacturers 90-120 days after the close of each quarter. We calculate, process, and send your rebate check in a timely manner."
  },
  {
    question: "How do you make money?",
    answer: "Adding you to the membership increases the volume for the GPO which allows us to earn a portion of rebates, as well."
  }
];

const FAQsPage: React.FC = () => {
  return (
    <FAQsPageWrapper>
      <PageTitle>Frequently Asked Questions</PageTitle>
      <IntroParagraph>
        Vending Rebates focuses on getting members rebates on specific programs.
        We partner with Entegra / Sodexo to make these programs available to you.
        Our goal is to get you additional rebates on purchases from these
        manufacturers that you may not already be getting rebates on.
      </IntroParagraph>

      <FAQsSubheading>FAQs</FAQsSubheading>

      {faqsData.map((faq, index) => (
        <FAQItemWrapper key={index}>
          <FAQQuestion>Q: {faq.question}</FAQQuestion>
          <FAQAnswer>A: {faq.answer}</FAQAnswer>
        </FAQItemWrapper>
      ))}
    </FAQsPageWrapper>
  );
};

export default FAQsPage; 